import { mountApplications as mountEditApplications } from '~/pages/shared/wikis/async_edit';

mountEditApplications();
